// extracted by mini-css-extract-plugin
module.exports = {"isHighlighted":"Date__isHighlighted--32bB2"};